<div class="font-italic ml-3 mt-3">{{'Logging out, please wait...'|translate}}</div>